import { Component } from 'react'

// 全局错误边界：渲染期异常时给出友好提示和重载入口，避免白屏
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    if (!window.__pindouErrors) window.__pindouErrors = []
    const record = 'React render error: ' + (error && error.stack ? error.stack : String(error)) +
        (info && info.componentStack ? '\n' + info.componentStack : '')
    window.__pindouErrors.push(record)
    this.setState({ errorInfo: record })
    // 同时输出到控制台，便于远程调试
    console.error('[ErrorBoundary]', error, info)
  }

  render() {
    if (this.state.error) {
      const errMsg = this.state.error?.message || String(this.state.error)
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-cream-50 p-6 text-center text-cocoa">
          <div className="text-4xl">🌱</div>
          <p className="text-lg font-semibold">页面出了点小问题</p>
          <p className="max-w-md text-sm text-cocoa-light">
            可能是缓存或网络导致的，请尝试重新加载。若多次出现请截图联系开发者。
          </p>
          <div className="max-w-lg rounded-xl bg-white/80 p-4 text-left">
            <p className="mb-1 text-xs font-semibold text-cocoa">错误详情（请截图给开发者）：</p>
            <pre className="max-h-40 overflow-auto rounded-lg bg-cream-100 p-2 text-[11px] text-cocoa-light break-all">
              {errMsg}
            </pre>
          </div>
          <button className="btn-primary" onClick={() => window.location.reload()}>
            重新加载
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
